const PARTNER_PROMO_ENTRY_STORAGE_KEY = 'partner-filter-shown';
const PARTNER_PROMO_PAGE_PATH = '/veterinars/online/besplatnaya-onlayn-konsultaciya-veterinara/';

const normalizePath = (path: string): string => (path.endsWith('/') ? path : `${path}/`);

export function usePartnerPromoEntry() {
  const partnerPromoPagePath = PARTNER_PROMO_PAGE_PATH;

  const isPartnerPromoPage = (path: string): boolean => {
    return normalizePath(path) === partnerPromoPagePath;
  };

  const hasPartnerPromoEntry = (): boolean => {
    if (!import.meta.client) {
      return false;
    }

    return sessionStorage.getItem(PARTNER_PROMO_ENTRY_STORAGE_KEY) === 'true';
  };

  const markPartnerPromoEntry = (): void => {
    if (!import.meta.client) {
      return;
    }

    sessionStorage.setItem(PARTNER_PROMO_ENTRY_STORAGE_KEY, 'true');
  };

  const isPartnerPromoEntryRoute = (route: { path?: string }): boolean => {
    const path = route.path || '';

    return isPartnerPromoPage(path);
  };

  return {
    partnerPromoPagePath,
    isPartnerPromoPage,
    hasPartnerPromoEntry,
    markPartnerPromoEntry,
    isPartnerPromoEntryRoute,
  };
}
